export const API_ENDPOINTS = {
  SUPPLIER: {
    List: '/suppliers',
    Create: '/suppliers',
    Details: '/suppliers/{id}',
    Update: '/suppliers/{id}',
    Delete: '/suppliers/{id}',
    Bulk: '/suppliers/bulk',
  },
};
